import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-attendance-main-dashboard',
  templateUrl: './attendance-main-dashboard.component.html',
  styleUrls: ['./attendance-main-dashboard.component.scss']
})
export class AttendanceMainDashboardComponent implements OnInit {
  isAdmin: boolean = false;
  isAttendanceUser: boolean = false;
  isManager: boolean = false; // New property for Manager role

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.checkUserRole();
  }

  private checkUserRole(): void {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      this.isAdmin = currentUser.role === 'Admin';
      this.isAttendanceUser = currentUser.role === 'Attendance';
      this.isManager = currentUser.role === 'Attendance'; // Manager uses Attendance role
    }
  }

  navigateToEmployees(): void {
    this.router.navigate(['/attendance/employees']);
  }

  navigateToClockInOut(): void {
    this.router.navigate(['/attendance/clock-in-out']);
  }

  navigateToReports(): void {
    this.router.navigate(['/attendance/reports']);
  }

  navigateToMonthlyReport(): void {
    this.router.navigate(['/attendance/monthly-report']);
  }

  navigateToManualEntry(): void {
    this.router.navigate(['/attendance/manual-entry']);
  }

  navigateToSalary(): void {
    this.router.navigate(['/attendance/salary']);
  }

  navigateToImport(): void {
    this.router.navigate(['/attendance/import']);
  }

  navigateToIndividualPunchImport(): void {
    this.router.navigate(['/attendance/import-individual-punches']);
  }

  navigateToDevices(): void {
    this.router.navigate(['/attendance/devices']);
  }

  navigateToTodayDashboard(): void {
    this.router.navigate(['/attendance/dashboard']);
  }
} 